import React from 'react'
import {FaEllipsisH} from 'react-icons/fa'
import { AboutCompany } from './aboutCompany'
import { PreviewImages } from './previewImages'
import { TeamMember } from './teamMember'
import { Feed } from './feed'
import { Aboutus } from './aboutUs'
import { ShowcaseHorizontal } from './showcase'
import { MyProjects } from './myProjects'
import { Profiles } from './profiles'
import { AboutEdit } from './aboutEdit'
import { About } from './about'
import { SingleRequest } from './singleRequest'
import { Friends } from './friends'
import { Suggestions } from './suggestions'
import Navbar from '../../../@shared/navigations/default'

const ProfilesGridPage = () =>{
    return( 
        <React.Fragment>
            <Navbar />
            <section className="profile project-page page" id="profile">
                <div className='cover'>
                <div className="logo">NOVA</div>
                </div>
                <div className="activity">
                    <div className="container-1035 wrapper">
                        <img src="/assets/images/faces/13.png" className="avatar" alt="" />
                        <div className="wrapper">
                            <ul>
                                <li className="active"> 
                                    <div>
                                        <span>Followers</span>
                                        <p>2,215</p>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <span>Following</span>
                                        <p>3,925</p>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <span>Likes</span>
                                        <p>50,825</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="buttons">
                            <a className="button button-yellow">Follow</a>
                            <a className="button button-secondary">
                                <FaEllipsisH />
                            </a>
                        </div>
                    </div>
                </div>

                <div className=" container ">
                    <div className=" row">
                        <div className="col-md-3">
                            <div className="mt-5 text-center">
                                <h2 className='name gray'>Ahmad</h2>
                                <h3 className='slug'>@ahmad</h3>
                                <p className="mt-2">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                    Optio laudantium laborum dolorum.
                                    Quis voluptate nisi sed dolorum, repellendus deserunt.
                                </p>

                            <div className="button button-yellow follow-button">Follow</div>
                                <AboutCompany />
                                <PreviewImages />
                                <TeamMember /> 
                            </div>
                        </div>
                        <div className="col-md-6">
                            <Feed />
                            <Aboutus />
                            <ShowcaseHorizontal />
                            <MyProjects />
                             <Profiles />
                            <AboutEdit />
                            <About /> 
                         
                        </div>
                        <div className="col-md-3">
                        <SingleRequest />
                        <Friends />
                        <Suggestions />
                           
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    )
}

export default ProfilesGridPage;

